import React from 'react';
import {
  PlannerPage,
  PlannerCard,
  PlannerKicker,
  PlannerHeading,
  PlannerSubtle,
} from './plannerTheme';

export default function ChurchPlannerResourcesPage() {
  return (
    <PlannerPage>
      <PlannerCard>
        <PlannerKicker>Library</PlannerKicker>
        <PlannerHeading>Resources</PlannerHeading>
        <PlannerSubtle>
          Attach chord charts, run sheets, and media links here in a future iteration.
        </PlannerSubtle>
      </PlannerCard>
    </PlannerPage>
  );
}
